import { createClient } from "@supabase/supabase-js";
import { ENV } from "./env";
/**
* Cliente Supabase singleton. Sesión persiste en localStorage (default).
* autoRefreshToken=true para que renueve el JWT antes de expirar sin que
* el usuario tenga que volver a logearse.
*/
export const supabase = createClient(ENV.SUPABASE_URL, ENV.SUPABASE_ANON_KEY, {
auth: {
autoRefreshToken: true,
persistSession: true,
detectSessionInUrl: true,
},
});
